import React from 'react';
import { useNewsData } from '../../../../hooks/useNewsData';
import {NavLink} from "react-router-dom";
import { newsDateConverter, getNewsCategory } from "../../../../components/converter";
import '../../../../styles/components/NewsCard.css';
import './FeaturedArticle.css';

const FeaturedArticle = () => {
  const { news, isLoading } = useNewsData();
  const latestNews = news[0];
  const previousNews = news.slice(1, 4);
    if (isLoading) {
        return <p style={{ marginBottom: '50rem' }}>Loading news...</p>;
    }
    return (
      <div className="featured-article">
        <article className="featured-article-latest">
            <NavLink key={latestNews.title} to={`neues/${latestNews.slug}`}>
            <div className="featured-article__container">
            <div className="featured-article__image-wrapper">
              <div className="featured-article__image-container">
                <div className="featured-article__gradient" />
                <img
                  src={latestNews.img}
                  alt="Artikel Bild"
                  className="featured-article__image"
                />
              </div>
            </div>
            <div className="featured-article__content">
              <h3 className="featured-article__title">{latestNews.title}</h3>
              <p className="featured-article__meta">
                {newsDateConverter(latestNews.publishedAt)} | {latestNews.readTime} read
              </p>
            </div>
          </div>
            </NavLink>
        </article>
          <div className="featured-article__previous-header">
              <h2>NEUESTE ARTIKEL</h2>
              <NavLink to="/neues">Alle Artikel -></NavLink>
          </div>
        <div className="featured-article__previous-container">
            {previousNews.map(item => {
                const category = getNewsCategory(item);
                return (
                    <NavLink key={item.id} className="news-card" to={`neues/${item.slug}`}>
                      <div className="news-card__media">
                        <img src={item.img} alt="Artikel Bild" loading="lazy"/>
                      </div>
                      <div className="news-card__body">
                        {category && <span className="news-card__tag">{category}</span>}
                        <h3 className="news-card__title">{item.title}</h3>
                        <div className="news-card__footer">
                          <div className="news-card__divider"/>
                          <span className="news-card__meta">{newsDateConverter(item.publishedAt)} &nbsp;·&nbsp; {item.readTime}</span>
                        </div>
                      </div>
                    </NavLink>
                );
            })}
        </div>
      </div>
  );
};

export default FeaturedArticle;
